module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("3dcDw"))).then(() => parcelRequire('1eLQZ'));